module.exports = __webpack_public_path__ + "media/images/icon/dashboard-a256e640491eb25bdc9c0e8d2f03dba6.svg";